import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom"; // 🔥 Añadimos useLocation
import "./MenuProd.css";
import ContactModal from "../components/ContactModal";
import Navbar from "../components/Navbar";
import CartModal from "../components/CartModal";
import { getProducts } from "../utils/productCache";

const MenuProd = () => {
  const navigate = useNavigate();
  const { category } = useParams();
  const location = useLocation(); // 🔥 Capturamos la ubicación actual para leer la query string

  const [products, setProduct] = useState([]);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // ESTADOS DEL CARRITO
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const allProducts = await getProducts();
        
        // 🔥 LÓGICA DUAL: BÚSQUEDA O CATEGORÍA
        const queryParams = new URLSearchParams(location.search);
        const searchQuery = queryParams.get("q");

        let filtered;

        if (searchQuery) {
          // Si hay una búsqueda, filtramos por nombre en todas las categorías
          filtered = allProducts.filter((p) =>
            p.product_name.toLowerCase().includes(searchQuery.toLowerCase())
          );
        } else {
          // Si no hay búsqueda, filtramos por la categoría de la URL
          filtered = allProducts.filter((p) => p.category === category);
        }

        setProduct(filtered);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [category, location.search]); // 🔥 Se ejecuta cuando cambia la categoría o la búsqueda

  // Función para agregar al carrito
  const addToCart = (product, e) => {
    e.stopPropagation();
    setCartItems([...cartItems, product]);
  };

  // Función para eliminar del carrito
  const removeFromCart = (index) => {
    const newCart = cartItems.filter((_, i) => i !== index);
    setCartItems(newCart);
  };

  // Manejador para la barra de búsqueda interna del menú
  const handleInternalSearch = (e) => {
    if (e.key === "Enter" && e.target.value.trim() !== "") {
      navigate(`/menu_prod/search?q=${encodeURIComponent(e.target.value.trim())}`);
    }
  };

  return (
    <div className="menu-site">

      {/* HEADER CON ICONO DE CARRITO */}
      <header className="menu-header">
        <div className="menu-header-container">
          <div className="header-side-spacer"></div>

          <div className="menu-logo-section" onClick={() => navigate("/")}>
            <img
              src="/fiori_logo-Photoroom.png"
              alt="Fiori"
              className="menu-logo-img"
            />
          </div>

          <div className="header-cart-section">
            <button className="header-cart-btn" onClick={() => setIsCartOpen(true)}>
              <span className="cart-icon">🛒</span>
              {cartItems.length > 0 && (
                <span className="header-cart-badge">{cartItems.length}</span>
              )}
            </button>
          </div>
        </div>
      </header>

      {/* SEARCH INTERNO DEL MENÚ */}
      <div className="menu-search-section">
        <input
          type="text"
          placeholder="Buscar otro producto..."
          className="menu-search-bar"
          onKeyDown={handleInternalSearch}
        />
      </div>

      {/* NAVBAR */}
      <Navbar onOpenContact={() => setIsContactOpen(true)} />

      {/* TÍTULO DINÁMICO */}
      <div style={{ padding: '0 60px', marginTop: '20px' }}>
        <h2 style={{ color: '#2E5543' }}>
          {new URLSearchParams(location.search).get("q") 
            ? `Resultados para: "${new URLSearchParams(location.search).get("q")}"` 
            : category}
        </h2>
      </div>

      {/* PRODUCTOS */}
      <main className="menu-product-grid">
        {loading ? (
          <p style={{ padding: "20px" }}>Cargando productos...</p>
        ) : products.length === 0 ? (
          <p style={{ padding: "20px" }}>No se encontraron productos que coincidan.</p>
        ) : (
          products.map((product) => (
            <div
              key={product.product_id}
              className="menu-product-card"
              onClick={() => navigate(`/product/${product.product_id}`)}
            >
              <div className="menu-image-container">
                <img
                  src={product.url}
                  alt={product.product_name}
                  className="menu-product-img"
                />
              </div>

              <div className="menu-card-info">
                <p>{product.product_name}</p>
                <p className="menu-price">{product.cost}</p>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button className="menu-detail-btn" style={{ flex: 1 }}>
                    Detalles
                  </button>
                  <button 
                    className="menu-detail-btn" 
                    style={{ background: '#2E5543', width: 'auto' }}
                    onClick={(e) => addToCart(product, e)}
                  >
                    + Carrito
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </main>

      <ContactModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />

      <CartModal 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        cartItems={cartItems}
        onRemove={removeFromCart}
      />

      <footer className="menu-footer">
        <p>© 2026 FIORI floristería y eventos.</p>
      </footer>

    </div>
  );
};

export default MenuProd;